module.exports = __webpack_public_path__ + "img/realestate_banner.e7b6376c.png";